export const MEAL_CONFIG = {
    breakfast: {
        type: 1,
        title: 'Frukost',
        icon: '/assets/images/diary-icons/mug-hot.svg',
        icon_gray: '/assets/images/diary-icons/mug-hot-gray.svg',
        kcal: 530
    },
    lunch: {
        type: 3,
        title: 'Lunch',
        icon: '/assets/images/diary-icons/bowl-hot.svg',
        icon_gray: '/assets/images/diary-icons/bowl-hot-gray.svg',
        kcal: 530
    },
    dinner: {
        type: 5,
        title: 'Middag',
        icon: '/assets/images/diary-icons/plate-utensils.svg',
        icon_gray: '/assets/images/diary-icons/plate-utensils-gray.svg',
        kcal: 530
    },
    snack: {
        type: 8,
        title: 'Mellanmål',
        icon: '/assets/images/diary-icons/apple.svg',
        icon_gray: '/assets/images/diary-icons/apple-gray.svg',
        kcal: 530,
        bg: '#CAE090'
    },
    other: {
        type: 0,
        title: 'Snacks / Övrigt',
        icon: '/assets/images/diary-icons/strawberry.svg',
        icon_gray: '/assets/images/diary-icons/strawberry-gray.svg',
        kcal: 530,
        bg: '#EED1DF'
    }
};

export const MEAL_TYPE_MAP = Object.fromEntries(
    Object.entries(MEAL_CONFIG).map(([key, value]) => [value.type, key])
);

export const MEAL_NAME_MAP = Object.fromEntries(
    Object.values(MEAL_CONFIG).map(({ type, title }) => [type, title])
);
